import React from "react";
import { Box, Typography } from "@mui/material";
import SpendingGoalsTable from "./components/SpendingGoalsTable";
import { useFetchSpendingGoals } from "./hooks/useSpendingGoals";

const SpendingGoals = () => {
  const { data: spendingGoals, isLoading } = useFetchSpendingGoals();

  return (
    <Box display="flex" flexDirection="column" flex={1} width={"100%"}>
      <Box display="flex" flexDirection="row" flex={1} width={"100%"}>
        <Typography variant="h4" gutterBottom>
          Personal Challenges
        </Typography>
      </Box>
      <SpendingGoalsTable spendingGoals={spendingGoals} isLoading={isLoading} />
    </Box>
  );
};

export default SpendingGoals;
